'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _EyeTwoTone = _interopRequireDefault(require('./lib/icons/EyeTwoTone'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _EyeTwoTone;
exports.default = _default;
module.exports = _default;